<template>
  <logo-svg :alt :width :height />
</template>

<script setup lang="ts">
import LogoSvg from '~/assets/svg/logo.svg?component';

withDefaults(
  defineProps<{
    alt?: string;
    width?: number;
    height?: number;
  }>(),
  {
    alt: 'g-portal-logo',
    width: 160,
    height: 20,
  },
);
</script>
